const Movie = () => {
  return (
    <div>
      <h1>Hi Again</h1>
    </div>
  );
};

export default Movie;
